//https://stackoverflow.com/questions/19721439/download-json-object-as-a-file-from-browser
type DownloadJsonOptions = {
  escapeMongoUrlSlashes?: boolean;
};

export function stringifyObjectAsJson(exportObj: any, options?: DownloadJsonOptions) {
  let json = JSON.stringify(exportObj, null, 2);

  if (options?.escapeMongoUrlSlashes) {
    json = json.replace(/("mongourl":\s*)"([^"]*)"/g, (_match, prefix, value) => `${prefix}"${value.replace(/\//g, "\\/")}"`);
  }

  return json;
}

export function downloadObjectAsJson(exportObj: any, exportName: string, options?: DownloadJsonOptions) {
  const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(stringifyObjectAsJson(exportObj, options)); //pretty print JSON
  const downloadAnchorNode = document.createElement("a");
  downloadAnchorNode.setAttribute("href", dataStr);
  downloadAnchorNode.setAttribute("download", exportName + ".json");
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}

export function downloadObjectAsText(exportObj: any, exportName: string, ext: string = "txt") {
  const dataStr = "data:text/plain;charset=utf-8," + encodeURIComponent(exportObj); //pretty print JSON
  const downloadAnchorNode = document.createElement("a");
  downloadAnchorNode.setAttribute("href", dataStr);
  downloadAnchorNode.setAttribute("download", `${exportName}.${ext}`);
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}
